import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=cc37a97a&scoped=true&"
import script from "./section6.vue?vue&type=script&lang=js&"
export * from "./section6.vue?vue&type=script&lang=js&"
import style0 from "./section6.vue?vue&type=style&index=0&id=cc37a97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc37a97a",
  null
  
)

export default component.exports